import gql from "graphql-tag"

const CREATE_OR_UPDATE_DISCOUNT_EXTERNAL_RULE = gql`
  mutation createOrUpdateDiscountExternalRule(
    $id: ID!
    $input: InputCreateOrUpdateDiscountExternalRule!
  ) {
    createOrUpdateDiscountExternalRule(
      id: $id
      discountExternalRule: $input
    ) {
      id
    }
  }
`

export default CREATE_OR_UPDATE_DISCOUNT_EXTERNAL_RULE
